
export default {
  name: 'BaseNavigatorStreamCardUserMenu',
  props: {
    stream: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      isCopyId: false,
      isShowMenu: false,
    }
  },
  computed: {
    isAllowShowMenu() {
      if (!this.$auth?.loggedIn) {
        return false
      } else {
        return (
          this.$auth.user.roles.find((role) => role === 'ADMIN') ||
          this.$auth.user.roles.find((role) => role === 'MODERATOR')
        )
      }
    },
  },
  methods: {
    async copyId(id) {
      if (typeof navigator.clipboard === 'undefined') {
        const textArea = document.createElement('textarea')
        textArea.value = id
        textArea.style.position = 'fixed'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          document.execCommand('copy')
          this.isCopyId = true
        } catch (err) {
          this.isCopyId = false
        }
        document.body.removeChild(textArea)
        return
      }
      await navigator.clipboard.writeText(id).then(() => {
        this.isCopyId = true
      })
      setTimeout(() => {
        this.closeMenu()
        this.isCopyId = false
      }, 500)
    },
    closeMenu() {
      this.isShowMenu = false
    },
    // async postToDraft() {
    //   await this.$axios.$put(`/article/drafted/${this.post._id}`)
    //   this.closeMenu()
    //   this.$emit('update')
    // },

    // async removePost() {
    //   this.isShowMenu = false
    //   const isRemove = await this.$refs.confirmDialogue.show({
    //     title: 'Удаление материала',
    //     message: 'Вы уверены? Эту операцию невозможно отменить.',
    //     okButton: 'Удалить материал',
    //   })
    //   if (isRemove) {
    //     await this.$axios.$delete(`/article/${this.post._id}`)
    //     this.$emit('remove')
    //   }
    //   this.closeMenu()
    // },
  },
}
